import { useLocation, useParams } from "react-router-dom";

/** Resolve workspace vs directory person detail route params. */
export function usePersonDetailRoute() {
  const location = useLocation();
  const params = useParams<{
    leadId?: string;
    personId?: string;
    tab?: string;
  }>();
  const isMutable = location.pathname.startsWith("/user/leads");
  const detailId = isMutable ? params.leadId : params.personId;
  const peopleBase: "/user/leads" | "/people" = isMutable
    ? "/user/leads"
    : "/people";
  return {
    detailId,
    isMutable,
    peopleBase,
    tab: params.tab,
  };
}
